<template>
  <Page
    :loading="isLoadingPage"
    :spinning="isSpinning"
    class="base-table"
  >
    <PageTitle>Administrationsveje</PageTitle>
    <p v-if="getAllRouteOfAdministration.length === 0">
      Der er ingen oprettede administrationsveje.
    </p>

    <div class="row">
      <div
        class="col-xs-12 col-xl-12"
        v-if="getAllRouteOfAdministration.length"
      >
        <div class="row bottom-xs base-table__header">
          <p class="col-xs-2 col-xl-1">
            Importkoder
          </p>
          <p class="col-xs-5 col-xl-3">
            Navn
          </p>
          <p class="col-xs-5 col-xl-6">
            Beskrivelse
          </p>
        </div>
        <Box
          v-for="(routeOfAdministation, routeOfAdministationIndex) in getAllRouteOfAdministration"
          :key="routeOfAdministationIndex"
          :open="routeOfAdministation.editMode"
        >
          <div class="row">
            <div class="col-xs-2 col-xl-1">
              {{ displayImportCodes(routeOfAdministation.importRefferenceCodes) }}
            </div>
            <div class="col-xs-4 col-xl-3">
              {{ routeOfAdministation.info.name }}
            </div>
            <div class="col-xs-4 col-xl-6">
              {{ routeOfAdministation.info.description }}
            </div>
            <div class="col-xs-2 end-xs">
              <font-awesome-icon
                class="base-table__icon-edit"
                icon="pencil-alt"
                @click="toggleEditMode(routeOfAdministation)"
              />
              <font-awesome-icon
                class="base-table__icon-delete"
                icon="trash-alt"
                v-if="routeOfAdministation.info.deletable"
                @click="deletePrompt(routeOfAdministation)"
              />
            </div>
          </div>
          <div
            class="row"
            v-if="routeOfAdministation.editMode"
          >
            <div class="col-xs-12">
              <UpdateRouteOfAdministation
                :form="routeOfAdministation"
                @updated="loadImportCodes"
                :import-codes="importRefferenceCodes"
              />
            </div>
          </div>
        </box>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <CreateRouteOfAdministation
          @created="apiCreated"
          :import-codes="importRefferenceCodes"
        />
      </div>
    </div>
  </Page>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Page from './Page.vue';
import UpdateRouteOfAdministation from '../components/Forms/RouteOfAdministation/UpdateRouteOfAdministation.vue';
import CreateRouteOfAdministation from '../components/Forms/RouteOfAdministation/CreateRouteOfAdministation.vue';
import Box from '../components/Box.vue';
import RouteOfAdministrationService from '../services/RouteOfAdministrationService';
import Pageload from '../mixins/Pageload';
import Request from '../mixins/Request';
import IsActive from '../filters/IsActive';
import IsExtended from '../filters/IsExtended';

export default {
    name: 'RouteOfAdministation',
    mixins: [Pageload, Request],
    components: {
        Box, CreateRouteOfAdministation, UpdateRouteOfAdministation, Page,
    },
    filters: { IsActive, IsExtended },
    data() {
        return {
            importRefferenceCodes: [],
        };
    },
    computed: {
        ...mapGetters('routeofadministration', [
            'getAllRouteOfAdministration',
        ]),
    },
    methods: {
        ...mapActions('routeofadministration', [
            'loadRouteOfAdministrationWithDeleteFlags',
        ]),
        displayImportCodes(codes) {
            return Array.isArray(codes) ? codes.join(', ') : '';
        },
        toggleEditMode(api) {
            this.$set(api, 'editMode', !api.editMode);
        },
        async apiCreated() {
            await this.initLoad();
        },
        async deleteAction(api) {
            try {
                const apiIndex = this.getAllRouteOfAdministration.findIndex(a => a === api);
                if (apiIndex === -1) {
                    return;
                }
                await RouteOfAdministrationService.delete(api.info.id);
                await this.initLoad();
                this.$snotify.success('Slettet.');
            } catch (error) {
                //
            }
        },
        deletePrompt(api) {
            this.$snotify.confirm(`Vil du slette ${api.info.name}?`, {
                timeout: 5000,
                buttons: [
                    {
                        text: 'Ja',
                        action: (toast) => {
                            this.deleteAction(api);
                            this.$snotify.remove(toast.id);
                        },
                        bold: false,
                    },
                    {
                        text: 'Fortryd',
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                        },
                        bold: true,
                    },
                ],
            });
        },
        async initLoad() {
            try {
                await this.loadRouteOfAdministrationWithDeleteFlags();
                this.pageloaded();
            } catch (error) {
                //
            }
        },
        async loadImportCodes() {
            try {
                this.importRefferenceCodes = await RouteOfAdministrationService.unusedImportCodes();
            } catch (error) {
                //
            }
        },
    },
    async created() {
        await this.initLoad();
        await this.loadImportCodes();
    },
};
</script>
